import { render, staticRenderFns } from "./TotalPaymentInformation.vue?vue&type=template&id=f8c1fd9a&scoped=true&"
import script from "./TotalPaymentInformation.vue?vue&type=script&lang=js&"
export * from "./TotalPaymentInformation.vue?vue&type=script&lang=js&"
import style0 from "./TotalPaymentInformation.vue?vue&type=style&index=0&id=f8c1fd9a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c1fd9a",
  null
  
)

export default component.exports